import { APP_CONFIG } from 'app-config';

export const ITEMS_PER_INFINITE_SCROLL = 20;
export const LEGACY_EMPLOYER_PROFILE = `${APP_CONFIG.REACT_APP_WR_URL}/admin/employers/`;
